<template>
  <div class="h5-layout">
    <app-main class="h5-layout__content" />
    <navbar class="h5-layout__tabbar" />
  </div>
</template>

<script>
import { Navbar, AppMain } from "./components/index";

export default {
  name: "H5Layout",
  components: {
    Navbar,
    AppMain,
  },
};
</script>

<style lang="scss" scoped>
.h5-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f7f8fa;
}

.h5-layout__content {
  flex: 1;
  overflow-y: auto;
}

.h5-layout__tabbar {
  position: sticky;
  height: 1.875rem;
  padding: .9375rem 0;
  bottom: 0;
}
</style>
